var map = {
	"./HOME_CLOCK_IN.svg": "cdf5",
	"./HOME_CLOCK_OUT.svg": "e4ac",
	"./TRAINING_IN.svg": "da7d",
	"./TRAINING_OUT.svg": "bb1e",
	"./fonts/timeware.svg": "434c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";